import i18n from '@/i18n'
import { COMPANY_ADMIN_MENU_GROUP_KEY } from '@/constant/company'
import Layout from '../layout.vue'
import Index from './index.vue'

const basePath = '/v-admin/wechat-template-message-management'

export default {
  name: 'weChatTemplateManagement',
  path: `${basePath}`,
  component: Layout,
  redirect: `${basePath}/list`,
  meta: {
    isInclude: true,
    isRootLayout: true,
    titleI18nKey: 'admin.company.weChatTemplate.title.weChatTemplateMessageManagementTitle',
    permission: ['PREMIUM_WECHAT_TEMPLATE_MESSAGE', 'PERM_WECHAT_TEMPLATE_MESSAGE_MANAGEMENT'],
    menu: {
      get label () {
        return i18n.t('admin.company.weChatTemplate.title.weChatTemplateMessageManagementTitle')
      },
      group: COMPANY_ADMIN_MENU_GROUP_KEY.CUSTOMER_BRAND
    },
    isNewPage: true
  },
  children: [
    {
      name: 'weChatTemplateManagementIndex',
      component: Index,
      path: `${basePath}/list`,
      meta: {
        isInclude: true,
        hasBreadcrumb: true,
        titleI18nKey: 'admin.company.weChatTemplate.title.weChatTemplateMessageManagementTitle',
        menu: {
          get label () {
            return i18n.t('admin.company.weChatTemplate.title.weChatTemplateMessageManagementTitle')
          },
          group: COMPANY_ADMIN_MENU_GROUP_KEY.CUSTOMER_BRAND
        },
        isNewPage: true
      }
    }
  ]
}
